const scrollEventFn = (arr) => {
  arr.forEach((e) => {
    if (e.current) {
      const rect = e.current.getBoundingClientRect()
      if (rect.top <= window.innerHeight / 1.1) {
        e.current.classList.add('on')
      } else {
        e.current.classList.remove('on')
      }
    }
  })
}
export default scrollEventFn